import { decode } from 'html-entities'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'srcReact/SearchPage/components/styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import { useTranslation } from 'react-i18next'
import {
  getContentWithHighlightedText,
  getHighlightedSearchContent,
  matchedSearchInterestsInArray
} from 'srcReact/helpers/utils'
import { globalSearchActions } from 'srcReact/SearchPage'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import Avatar from 'srcReact/components/common2/Avatar'

const Members = ({ id, scope, isMobile, isNative, isHeader = false, infiniteScrollRef, isBackNavigation }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    globalSearch: { searchInterestText, members, searchSelectedMember, results }
  } = useSelector((state) => state)

  const iconSize = isHeader || isMobile ? 'medium' : 'large24'
  const handleMemberClick = (member) => {
    dispatch(globalSearchActions.setSearchSelectedMember(member))

    const lp = new LightProfileProto()
    lp.userId = member.id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  let searchedMembers = members
  if (scope === 'all') {
    searchedMembers = members.filter((m) => m.id === id)
  }

  return (
    <div className={styles.searchContentWrapper}>
      {searchedMembers?.length > 0 &&
        searchedMembers.map((m, i) => {
          const aboutText = results.find((res) => res.id === m.id && res.information_type === 'about')
          return (
            <button
              aria-label={t('globalSearch.accessibility.userName', { userName: `${m.firstname} ${m.lastname}` })}
              className={`${styles.searchContent} ${(isHeader || isMobile) && styles.headerContentWrapper}`}
              key={i}
              ref={infiniteScrollRef}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleMemberClick(m)}>
              <div className={`${styles.picture} ${styles.isMember}`}>
                <Avatar
                  imgWrapperSize='small48'
                  userId={m.user_id}
                  focusable={false}
                  profilePicture={m.profile_picture}
                  firstname={m.firstname}
                  lastname={m.lastname}
                  mimeType={m.mime_type}
                  originalTag={m.original_tag}
                  isOriginal={m.is_original}
                  showImageAsDecorative={true}
                  withExpertiseGroup={m.with_expertise_group}
                  ariaHidden={true}
                />
              </div>

              <div className={styles.heading}>
                <div className={styles.titleInterests}>
                  <div
                    className={styles.title}
                    dangerouslySetInnerHTML={{
                      __html: getContentWithHighlightedText(
                        `${decode(m.firstname) + ' ' + decode(m.lastname)}`,
                        searchInterestText
                      )
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: getHighlightedSearchContent(
                        `${decode(m.content?.message)}`,
                        matchedSearchInterestsInArray(m.interests, searchInterestText)
                      )
                    }}
                  />
                </div>
                {aboutText && (
                  <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{
                      __html: getContentWithHighlightedText(`${decode(aboutText.content)}`, searchInterestText, 15)
                    }}
                  />
                )}
              </div>

              <div className={`${styles.overlay} ${styles.isMember}`}>
                <Icon name='contact' size={iconSize} styleModifier={styles.customIcon} />
              </div>
            </button>
          )
        })}
    </div>
  )
}

export default Members
